/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Divider({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M2.6 1a.6.6 0 0 0-1.2 0v2A2.6 2.6 0 0 0 4 5.6h8A2.6 2.6 0 0 0 14.6 3V1a.6.6 0 1 0-1.2 0v2A1.4 1.4 0 0 1 12 4.4H4A1.4 1.4 0 0 1 2.6 3zM4 10.4A2.6 2.6 0 0 0 1.4 13v2a.6.6 0 1 0 1.2 0v-2A1.4 1.4 0 0 1 4 11.6h8a1.4 1.4 0 0 1 1.4 1.4v2a.6.6 0 1 0 1.2 0v-2a2.6 2.6 0 0 0-2.6-2.6zM2 7.1a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8M6 7.1a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8M10.9 8a.9.9 0 1 0-1.8 0 .9.9 0 0 0 1.8 0M14 7.1a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8" /></svg>;
}
;